// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Facts_wrapper__awURE","facts":"Facts_facts__Qrei1","fact":"Facts_fact__WeekV","fact__title":"Facts_fact__title__s6fpK","fact__value":"Facts_fact__value__mAIw4"};